import { render } from "./cookies.vue?vue&type=template&id=7d0ca6ea"
import script from "./cookies.vue?vue&type=script&lang=js"
export * from "./cookies.vue?vue&type=script&lang=js"

import exportComponent from "/Users/alex/Documents/Google Ads/Panorama Residence/Panorama web/panorama-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__